import { Component, Input, Output, EventEmitter } from '@angular/core';

import { EventListItem } from "./event-list-item.presentation";
import { DisplayEventWithTicketControls } from "./shopping-cart-event-list.component"

@Component({
	selector: 'shopping-cart-event-list-presentation',
	template: `
	<div class="shopping-cart__event-list" *ngFor="let event of displayEventsWithTicketControls">
		<event-list-item
		[displayEventWithTicketControls]="event"
		[editable]="editable"
		(removeTickets)="processRemoveTickets($event)"
		(eventTitleClicked)="eventTitleClicked.emit($event)"></event-list-item>
	</div>
`,
	styles: [require("./event-list.presentation.scss")]
})
export class ShoppingCartEventList {

	@Output() removeTickets = new EventEmitter<string[]>();
	@Output() eventTitleClicked = new EventEmitter<number>();

	@Input() displayEventsWithTicketControls: DisplayEventWithTicketControls[];
	@Input() editable: boolean

	processRemoveTickets(ticketItemUuidsToBeRemoved: string[]) {
		this.removeTickets.emit(ticketItemUuidsToBeRemoved)
	}
}



// WEBPACK FOOTER //
// ./src/app/components/shopping-cart/shopping-cart-event-list/event-list.presentation.ts